/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 納品（受入）可能フラグ（日曜日）
 * @export
 * @interface EnableArrivalSun
 */
export interface EnableArrivalSun {
}

/**
 * Check if a given object implements the EnableArrivalSun interface.
 */
export function instanceOfEnableArrivalSun(value: object): value is EnableArrivalSun {
    return true;
}

export function EnableArrivalSunFromJSON(json: any): EnableArrivalSun {
    return EnableArrivalSunFromJSONTyped(json, false);
}

export function EnableArrivalSunFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableArrivalSun {
    return json;
}

export function EnableArrivalSunToJSON(json: any): EnableArrivalSun {
    return EnableArrivalSunToJSONTyped(json, false);
}

export function EnableArrivalSunToJSONTyped(value?: EnableArrivalSun | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

